import React from "react";
import styled from "styled-components";

import { Container, SocialList } from "~/src/components";
import { down, spacings, colors, fonts } from "~/src/config/vars";

const FooterBottom = () => {
    return (
        <SFooterBottom>
            <Container size="large">
                <SBlock>
                    <SocialList />
                    <SCopyRight>Media Jasa ©2022</SCopyRight>
                </SBlock>
            </Container>
        </SFooterBottom>
    );
};

const SFooterBottom = styled.div`
    padding: ${spacings?.offset_40} 0;
    ${down("sm")} {
    }
`;

const SBlock = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const SCopyRight = styled.div`
    color: ${colors?.white};
    font-size: ${fonts?.fs_14};
    text-align: right;
`;

export default FooterBottom;
